import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { mainTheme } from '../../mainTheme.js';
import ProtectedRoutes from '../../components/ProtectedRoutes/index.js';
import UserContextProvider from '../../Context/User/index.js';
import WorkbookContextProvider from '../../Context/Workbook/index.js';
import NotebooksContextProvider from '../../Context/Notebooks/index.js';
import CreditsContextProvider from '../../Context/Credits/index.js';
import AdminAssessmentsContextProvider from '../../Context/AdminAssessments/index.js';
import UserAssessmentsContextProvider from '../../Context/UserAssessments/index.js';
import { NavigationContextProvider } from '../../Context/Navigation';
import { Toaster } from 'react-hot-toast';
import { PodcastPlayerContextProvider } from '../../Context/Podcast/PodcastPlayerContext';

export const App = () => {
  return (
    <ThemeProvider theme={mainTheme}>
      <Toaster
        position="bottom-center"
        reverseOrder="false"
        toastOptions={{
          success: {
            iconTheme: {
              primary: '#00998c',
              secondary: '#FFF'
            }
          }
        }}
      />
      <PodcastPlayerContextProvider>
        <UserContextProvider>
          <NavigationContextProvider>
            <WorkbookContextProvider>
              <CreditsContextProvider>
                <NotebooksContextProvider>
                  <AdminAssessmentsContextProvider>
                    <UserAssessmentsContextProvider>
                      <ProtectedRoutes />
                    </UserAssessmentsContextProvider>
                  </AdminAssessmentsContextProvider>
                </NotebooksContextProvider>
              </CreditsContextProvider>
            </WorkbookContextProvider>
          </NavigationContextProvider>
        </UserContextProvider>
      </PodcastPlayerContextProvider>
    </ThemeProvider>
  );
};
